import React, {useEffect, useContext, useState} from 'react';
import {Link} from 'react-router-dom';
import {OpenApiContext} from '../../openapi-context';
import {Typography, Tabs} from 'antd';
import {EyeOutlined, CodeOutlined} from '@ant-design/icons';
import {OverviewBlock} from './overview-block';
import {TechnicalEditor} from '../technical-editor';
import {capitalCase} from 'change-case';
import {Block} from '../block';
import {GlobalSecurityBlock} from './global-security-block';

export function FrontPage({spec, dispatch, params, version, rootPath}) {
    const [info, setInfo] = useState();
    const openapi = useContext(OpenApiContext);
    const {state} = useContext(OpenApiContext);

    useEffect(() => {
        if (openapi.state.info) {
            setInfo(openapi.state.info());
        }
    }, [openapi.state]);

    function buildUrl(target) {
        if (!params) {
            return '/standards';
        }

        return `/${params.env}/standards/${params.category}/${params.key}/${version}${target}`;
    }

    function onSchemaSave(info) {
        return function (spec) {
            dispatch({type: 'update-info', spec});
        };
    }

    function onSecuritySchemeSave(globalSecurity) {
        dispatch({type: 'update-global-security', globalSecurity});
    }

    function onTechnicalEdit(spec) {
        dispatch({type: 'update-info', spec});
    }

    return info ? (
        <div className="frontpage">
            <Tabs
                type="card"
                tabPlacement="right"
                id="modelTabs"
                items={[
                    {
                        key: 'visual',
                        label: <EyeOutlined />,
                        children: (
                            <div className="scrollableViewer">
                                <Typography.Title level={2}>{info.title && capitalCase(info.title)}</Typography.Title>
                                {info.summary && (
                                    <Typography.Paragraph className="infoSummary">
                                        <Typography.Text strong>{info.summary}</Typography.Text>
                                    </Typography.Paragraph>
                                )}
                                <Typography.Paragraph>
                                    <strong>Version</strong>: {info.version}, <strong>OpenAPI Schema Version:</strong> {openapi.state.schemaVersion()}
                                    {openapi.state.jsonSchemaDialect && openapi.state.jsonSchemaDialect() && (
                                        <>
                                            , <strong>JSON Schema Dialect:</strong>{' '}
                                            <Typography.Text code>{openapi.state.jsonSchemaDialect()}</Typography.Text>
                                        </>
                                    )}
                                </Typography.Paragraph>
                                <OverviewBlock schema={spec.info} onSave={onSchemaSave(spec)} rootPath={rootPath} />
                                <Block noEdit>
                                    {state.editMode === false && (
                                        <div>
                                            <Typography.Title style={{marginTop: '15px'}} level={4}>
                                                Table Of Contents
                                            </Typography.Title>
                                            <ul>
                                                <li>
                                                    <Link to={buildUrl('/overview')}>Overview</Link>
                                                </li>
                                                <li>
                                                    <Link to={buildUrl('/overview/contact')}>Contacts</Link>
                                                </li>
                                                <li>
                                                    <Link to={buildUrl('/overview/license')}>License</Link>
                                                </li>
                                                <li>
                                                    <Link to={buildUrl('/overview/servers')}>Servers</Link>
                                                </li>
                                                <li>
                                                    <Link to={buildUrl('/models')}>Components (Models)</Link>
                                                </li>
                                                <li>
                                                    <Link to={buildUrl('/interfaces')}>Paths (Interfaces)</Link>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </Block>
                                <GlobalSecurityBlock securityData={spec.security} onSave={onSecuritySchemeSave} />
                            </div>
                        ),
                    },
                    {
                        key: 'technical',
                        label: <CodeOutlined />,
                        disabled: openapi.state.editMode,
                        children: (
                            <Block noEdit>
                                <TechnicalEditor object={info} update={onTechnicalEdit} />
                            </Block>
                        ),
                    },
                ]}
            />
        </div>
    ) : null;
}
